import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent, useEffect, useState } from 'react';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  brandController,
  campaignSigningDocumentController,
} from '@/apis/core';
import { Loader, PDFViewer } from '@/shared_elements';

interface LoaPreviewModalProps {
  brandUid?: string;
  campaignUid?: string;
  docUid: string;
  onClose?: () => void;
}

const LoaPreviewModal: FunctionComponent<LoaPreviewModalProps> = ({
  brandUid,
  campaignUid,
  docUid,
  onClose,
}) => {
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    let active = true;
    let createdUrl = '';

    (async () => {
      let response;
      if (campaignUid) {
        response = await campaignSigningDocumentController.getLoaDoc(
          campaignUid,
          docUid,
          {
            format: 'pdf',
          }
        );
      } else if (brandUid) {
        response = await brandController.getLoaDoc(brandUid, docUid, {
          format: 'pdf',
        });
      }

      if (active && response) {
        const { data, filename } = response;
        // Prevent memory leak if the component is unmounted before the API call returns
        const file = new File([data], filename, {
          type: 'application/pdf',
        });
        createdUrl = URL.createObjectURL(file);
        setPreviewUrl(createdUrl);
      }
    })();

    return () => {
      active = false;
      if (createdUrl) {
        URL.revokeObjectURL(createdUrl);
      }
    };
  }, [brandUid, campaignUid, docUid]);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(73, 83, 93, 0.85)',
        backdropFilter: 'blur(7.5px)',
        zIndex: 1500,
      }}
      data-testid="loaPreviewModal"
    >
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          top: '96px',
          right: '114px',
          width: '48px',
          height: '48px',
          color: 't.white',
          fontSize: '28px',
          cursor: 'pointer',
        }}
        onClick={onClose}
        data-testid="close"
      >
        <FontAwesomeIcon icon={faXmark} />
      </Flex>

      {previewUrl ? (
        <PDFViewer
          sx={{
            position: 'absolute',
            top: '47px',
            right: 0,
            bottom: 0,
            left: 0,
            width: '842px',
            height: 'calc(100vh - 47px)',
            margin: '0 auto',
          }}
          width={842}
          url={previewUrl}
        />
      ) : (
        <Loader hocFlag />
      )}
    </Box>
  );
};

export default LoaPreviewModal;
